import { createFileRoute, redirect } from "@tanstack/react-router";
import Login from "../pages/Login";
import { hasValidSession } from "../utils/auth";

export const Route = createFileRoute("/login")({
  beforeLoad: () => {
    // Mirror AuthProvider bootstrap: expired access + refresh still counts.
    // Bare `accessToken` presence would bounce stale/expired tokens into `/`
    // and fight the root login redirect.
    if (hasValidSession()) throw redirect({ to: "/" });
  },
  component: Login,
});
